import HttpClientToken from '../../services/HttpClientToken';

import { defaultPuesto, PuestoProps } from '../../interfaces/catalogos/PuestoInterface';

export const Puesto = () => {

    return new Promise<PuestoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Puesto/', token)
            .then( ({ data } : { data : PuestoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerPuestos = () => {

    return new Promise<PuestoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Puesto/ObtenerPuestos', token)
            .then( ({ data } : { data : PuestoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarPuesto = ( params: PuestoProps ) => {

    return new Promise<PuestoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Puesto/Actualizar', params, token)
            .then( ({ data } : { data : PuestoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPuesto } );
            });

        }

    });

}

export const AgregarPuesto = ( params: PuestoProps ) => {

    return new Promise<PuestoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Puesto/Agregar', params, token)
            .then( ({ data } : { data : PuestoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPuesto } );
            });

        }

    });

}
